export default class Constants {
    // static BASE_URL = "http://localhost:1009/";
    // static BASE_URL = "https://taskbuddyapi.appdeft.biz/";

    static BASE_URL = "https://taskbuddyapi.appdeft.in/"; // new
    static END_POINT = {
        SIGIN: "api/admin/login",
        CREATE_CATEGORY: "api/admin/create-category",
        GET_ALL_CATEGORIES: "api/admin/categories",
        ENABLE_DISABLE_CATEGORY: "api/admin/enable-disable-category/",
        USERS: "api/admin/users",
        BLOCK_UNBLOCK_USER: "api/admin/enable-disable-user/",
        GET_ADMIN_PROFILE: "api/admin/profile",
        UPDATE_ADMIN_PROFILE: "api/admin/update",
        CHANGE_PASSWORD: "api/admin/change-password",
        FORGOT_PASSWORD: "api/admin/forgot-password",
        RESET_PASSWORD: "api/admin/change-forgot-password",
        UPDATE_CATEGORY: "api/admin/update-category/",

        // Providers

        PROVIDERS: "api/admin/providers",
        BLOCK_UNBLOCK_PROVIDER: "api/admin/enable-disable-provider/",
        GET_PROVIDER: "api/admin/provider/",
        VERIFY_BUSINESS_PROVIDER: "api/admin/verify-business/",

        // Amenities
        GET_ALL_AMENITIES: "api/admin/amenities",
        CREATE_AMENITIES: "api/admin/create-amenities",
        UPDATE_AMINITIES: "api/admin/update-amenity/",
        DELETE_AMENITIES: "api/admin/delete-amenities/",

        //safety Rules
        GET_ALL_SAFETY_RULES: "api/admin/safety-rules",
        CREATE_SAFETY_RULES: "api/admin/create-safety-rules",
        UPDATE_SAFETY_RULES: "api/admin/update-safety-rules/",
        DELETE_SAFETY_RULES: "api/admin/delete-safety-rules/",

        GET_ALL_BUSINESS_REPORTS: "api/admin/get-all-business-reports",
        GET_ALL_PROVIDER_FEEDBACK: "api/admin/feedbacks",
        GET_ALL_USERS: "api/admin/users",

        GET_USER_BOOKINGS: "api/admin/user/bookings/",
        GET_PROVIDER_BOOKINGS: "api/admin/provider/bookings/",
        GET_COUNT: "api/admin/count",
        ALL_BOOKINGS: "api/admin/all-bookings",
        PAYMENTS: "api/admin/my-earnings",

        //Reviews
        GET_ALL_BUSINESS_REVIEWS: "api/admin/reviews",
        DELETE_BUSINESS_REVIEWS: "api/admin/review/",
        //Term & Consition
        CREATE_TERM_CONDITION: "api/admin/create-term-and-condition/",
        GET_TERMS_CONDITION: "api/admin/term-and-condition",
        UPDATE_TERM_CONDITION: "api/admin/update-term-and-condition/",
        DELETE_TERM_CONDITION: "api/admin/delete-term-and-condition/",
        //Privacy Policy
        CREATE_PRIVACY_POLICY: "api/admin/create-privacy-policy/",
        GET_PRIVACY_POLICY: "api/admin/privacy-policy",
        UPDATE_PRIVACY_POLICY: "api/admin/update-privacy-policy/",
        DELETE_PRIVACY_POLICY: "api/admin/delete-privacy-policy/",
        //PromotionsPlans
        POST_ADD_PROMOTIONS: "api/admin/plan/",
        GET_TABLE_DATA_PROMOTIONS: "api/admin/plan/",
        DELETE_TABLE_DATA_PROMOTIONS: "api/admin/plan/",
        EDIT_TABLE_DATA_PROMOTIONS: "api/admin/plan/",
    };
}
